
import { HttpQueryAccount } from '@/service/recharge';
import TableList from "@components/templates/tablelist";
import { mapState,mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    // components: {
    //     compSubmit,
    //     compLogistics,
    // },
    data() {
        return {
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                    
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: {show: true},
            isSuper: this.$store.state.userinfo.isSuper
        };
    },
    methods: {
        ajaxRequest: HttpQueryAccount,
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'recharge':
                    this.$router.push({
                        name: 'rechargeAccount',
                    });
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/funding/rechargeRecord/export",this.formData,
                        "download"
                    );
                    break;
            }
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getNextOrgList']),
        ToolsData(){
            return [
                {
                    name: this.$t('fbb.freeze.nowrecharge', { defaultValue: '立即充值' }),
                    operate: "recharge",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: "export",
                    theme: "info",
                },
            ]
        },
        SearchsData() {
            return  [
                {
                    label: this.$t('global.common.organization', { defaultValue: '组织' }),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    show:true,
                    options:this.getNextOrgList,
                    props:{
                        filterable:true,
                    }
                },
                {
                    label: this.$t('fbb.rechage.datefunds', { defaultValue: '资金到账日期' }),
                    key: 'BT_arrivalDate',
                    show:true,
                    tag: 'vDatepicker',
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                {
                    label: this.$t('fbb.bill.freeze_createdat', { defaultValue: '创建日期' }),
                    key: 'BT_createdAt',
                    show:true,
                    tag: 'vDatepicker',
                    props:{
                        format:'yy-mm-dd ~ yy-mm-dd',
                        confirm:false,
                    },
                },
                
            ]
        },
        columns() {
            return [
            {
                title: this.$t('fbb.rechage.datefunds', { defaultValue: '资金到账日期' }),
                key: 'arrivalDate',
                sortable: true
            }, {
                title: this.$t('fbb.bill.account_org', { defaultValue: '账户组织' }),
                key: 'organizationName',
            }, {
                title: this.$t('fbb.rechage.topupamount', { defaultValue: '充值金额' })+'(USD)',
                key: 'amount',
                sortable: true
            }, {
                title: this.$t('fbb.rechage.accountbalance', { defaultValue: '账户余额' })+'(USD)',
                key: 'availableAmountSnapshot',
                sortable: true
            }, {
                title: this.$t('global.common.notes', { defaultValue: '备注' }),
                key: 'remark',
            }, {
                title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                key: 'createdName',
                
            }, {
                title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                key: 'createdAt',
                
            }];
        },
    },
};




